import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import CloudUpload from '@material-ui/icons/CloudUpload';
import Close from '@material-ui/icons/Close';
import intl from 'react-intl-universal';

const UploadPad = ({ dropHandler, acceptedFileTypes, closeHandler }) => (
  <Dropzone className="attachment" onDrop={dropHandler} accept={acceptedFileTypes}>
    <CloudUpload className="icon large-icon" />
    <br />
    {intl.get('controls.uploadText')}
    <span className="action-link">{intl.get('controls.uploadBrowse')}</span>
    {closeHandler && (
      <nav className="nav-bar">
        <Close className="icon md" onClick={closeHandler} />
      </nav>
    )}
  </Dropzone>
);

UploadPad.propTypes = {
  dropHandler: PropTypes.func.isRequired,
  acceptedFileTypes: PropTypes.string,
  closeHandler: PropTypes.func,
};

export default UploadPad;
